"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TagPickerGroup: function() {
        return _index.TagPickerGroup;
    },
    renderTagPickerGroup_unstable: function() {
        return _index.renderTagPickerGroup_unstable;
    },
    tagPickerGroupClassNames: function() {
        return _index.tagPickerGroupClassNames;
    },
    useTagPickerGroupStyles_unstable: function() {
        return _index.useTagPickerGroupStyles_unstable;
    },
    useTagPickerGroup_unstable: function() {
        return _index.useTagPickerGroup_unstable;
    }
});
const _index = require("./components/TagPickerGroup/index");
